import { create } from 'zustand';

interface StartupCmdState {
  isStartupCmdSelected: boolean;
  executionCommand: string;
  parameters: string;
  tty: boolean;
}

const initState: StartupCmdState = {
  isStartupCmdSelected: false,
  executionCommand: '',
  parameters: '',
  tty: false,
};

interface StartupCmdActions {
  updateExecutionCommand: (command: string) => void;
  updateParameters: (params: string) => void;
  toggleStartupCmdSelected: (value: boolean) => void;
  reset: () => void;
  updateTTY: (value: boolean) => void;
}

export const useStartupCmdStore = create<StartupCmdState & StartupCmdActions>()((set, get) => ({
  ...initState,
  updateExecutionCommand: (command: string) => set({ executionCommand: command }),
  updateParameters: (params: string) => set({ parameters: params }),
  toggleStartupCmdSelected: (value: boolean) => set({ isStartupCmdSelected: value }),
  reset: () => set(initState),
  updateTTY: (value: boolean) => set({ tty: value }),
}));
